module.exports = __webpack_public_path__ + "static/img/2.舊衣募集.d15e270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/2.舊衣募集.jpg
// module id = QCte
// module chunks = 98